import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { collectionServices } from '@hero/services';

export const useDuplicateCollection = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();

  return useMutation(formData => collectionServices.create(formData), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetCollectionsKey] });
    },
    ...options
  });
};
